export const romanResearch = [
    { name: "Praetorian", wood: 700, clay: 620, iron: 1480, crop: 580, all: 3380 },
    { name: "Imperian", wood: 1000, clay: 740, iron: 1880, crop: 640, all: 4260 },
    { name: "Equites Legati", wood: 940, clay: 740, iron: 360, crop: 400, all: 2440 },
    { name: "Equites Imperatoris", wood: 3400, clay: 1860, iron: 2760, crop: 760, all: 8780 },
    { name: "Equites Caesaris", wood: 3400, clay: 2660, iron: 6600, crop: 1240, all: 13900 },
    { name: "Battering Ram", wood: 5500, clay: 1540, iron: 4200, crop: 580, all: 11820 },
    { name: "Fire Catapult", wood: 5800, clay: 5500, iron: 5000, crop: 700, all: 17000 },
    { name: "Senator", wood: 15875, clay: 13800, iron: 36400, crop:	22660, all:	88735}	
]